import { Pie } from "react-chartjs-2";
import { ChartColors } from "../Utility/Constants";
import { auto } from "@popperjs/core";

function PatientGenderChart() {

  return (
    <>
    <div>
      <div class="row justify-content-center align-items-center ms-2 mt-2">
        <div class="col-12">
          <Pie 
            data={
                {
                    labels: ["Male", "Female"], 
                    datasets: [
                      {
                        data: [30, 70],
                        backgroundColor: [
                          ChartColors.color1,
                          ChartColors.color4
                        ],
                        borderColor: "lightgrey",
                        borderWidth: 2
                      }
                    ]
                  }
            }
            
            options={{
              plugins: {
                datalabels: {
                    formatter: (value, ctx) => {
                      return value.toString() + "%";
                    },
                    color: '#fff',
                },
                title: {
                  text: "Gender Wise Distribution",
                  display: true,
                  align: "start"
                },
                legend: {
                    
                    position: "bottom",
                    labels : {
                        boxWidth: 10
                    }
                }
              },
            }}
          />
        </div>
      </div>
    </div>
    </>
  );
}

export default PatientGenderChart;
